export class QueryItemBuilder {
  static arrayProp(prop: any[] | undefined, queryLabel: string): string {
    if (prop) {
      return queryLabel + '=' + prop.join(',') + '&';
    }
    return '';
  }

  static booleanProp(prop: boolean | undefined, queryLabel: string): string {
    if (prop) {
      return queryLabel + '=true&'
    }
    return '';
  }

  static valueProp(prop: any | undefined, queryLabel: string): string {
    if (prop) {
      return queryLabel + '=' + prop + '&'
    }
    return '';
  }
}
